var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconQr = function SvgIconQr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    opacity: 0.48,
    transform: "translate(-46 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    opacity: 0,
    width: 24,
    height: 24,
    transform: "translate(46 -40)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "stroke:rgba(0,0,0,0)",
    d: "M2019-13945a1.923,1.923,0,0,1-2-2v-16a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v16a1.97,1.97,0,0,1-2,2c-.039.011-4.019.016-8,.016S2019.039-13944.989,2019-13945Zm0-2h16v-16h-16Zm12-2v-2h2v2Zm-10,0v-2h2v2Zm7-2v-3h3v3Zm-3,0v-2h2v2Zm-4-3v-7h7v7Zm8-1v-2h2v2Zm2-4v-2h2v2Z",
    transform: "translate(-1969 13927)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(52 -34)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconQr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-qr.ce802404.svg";
export { ForwardRef as ReactComponent };